import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axios from "axios";
import { BASE_END_POINT } from "./urls";

const firebaseConfig = {
  apiKey: "AIzaSyCTUJMXTu5D_Q2LohApSj8T7TB5HE65QRA",
  authDomain: "saaei-b43e6.firebaseapp.com",
  databaseURL: "https://saaei-b43e6-default-rtdb.firebaseio.com",
  projectId: "saaei-b43e6",
  storageBucket: "saaei-b43e6.appspot.com", // ✅ خلي بالك
  messagingSenderId: "1049231795506",
  appId: "1:1049231795506:web:ea6940f92134a1e1c2632b",
  measurementId: "G-7JGH5MLMFJ"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const getFcmToken = async (swRegistration) => {
  try {
    if (typeof window !== "undefined" && "Notification" in window) {
      if (Notification.permission !== "granted") {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
          console.log("⚠️ Notification permission denied.");
          return null;
        }
      }
    } else {
      console.log("⚠️ Notifications not supported in this browser.");
      return null;
    }

    const currentToken = await getToken(messaging, {
      vapidKey:
        "BOZ_bNWrxYFFkETYI_LoLgGog4xO7a4VLIR7AvaUs9QVZBM1LLI4q_3NB4etXIs-0ICfu08l_IGM6G0ftzN_FCk",
      // ✅ ربط التوكن بالـ Service Worker المسجل - ده اللي بيخلي الـ background notifications تشتغل
      serviceWorkerRegistration: swRegistration,
    });
    return currentToken;
  } catch (err) {
    console.error("😥 Error while retrieving token: ", err);
    return null;
  }
};

// 🟢 اطلب التوكن وابعت للسيرفر (بيستقبل الـ SW registration عشان الـ background تشتغل)
export const requestForToken = async (authToken, isRTL, swRegistration) => {
  try {
    const currentToken = await getFcmToken(swRegistration);

    if (currentToken) {
      console.log("🔥 FCM Token:", currentToken);

      await axios.post(`${BASE_END_POINT}addToken`,{ token: currentToken },
        {headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
            "Accept-Language": isRTL ? "ar" : "en",
          },
        }
      );
      console.log("✅ Token sent to backend");
    } else {
      console.log("⚠️ No registration token available.");
    }
  } catch (err) {
    console.error("😥 Error while retrieving token: ", err);
  }
};


// 🟢 استقبل رسائل لما التطبيق مفتوح (Foreground)
export const onMessageListener = (callback) =>
  onMessage(messaging, (payload) => {
    callback(payload);
  });
